import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';
import { format } from 'date-fns';

export const getAcHistoryDataTableStructure = (): DynamicDataTable => {
  const nameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.contractingAuthority.history.table.name',
    accessorKey: 'nom',
    variant: DataTableColumnVariant.TEXT,
  };
  const lastNameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.contractingAuthority.history.table.lastName',
    accessorKey: 'prenom',
    variant: DataTableColumnVariant.TEXT,
  };

  /*  const statusColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.contractingAuthority.history.table.status',
    accessorKey: 'status',
    variant: DataTableColumnVariant.TEXT,
  };*/

  const startDateColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.contractingAuthority.history.table.startDate',
    accessorKey: 'dateDebut',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: Date) => {
      return {
        value: value ? format(value, 'dd/MM/yyyy') : '---------',
      };
    },
  };

  const endDateColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.contractingAuthority.history.table.endDate',
    accessorKey: 'dateFin',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: Date) => {
      return {
        value: value ? format(value, 'dd/MM/yyyy') : '---------',
      };
    },
  };
  return {
    singular: 'settings.contractingAuthority.history.table.singular',
    plural: 'settings.contractingAuthority.history.table.plural',
    columns: [nameColumn, lastNameColumn /*, statusColumn*/, startDateColumn, endDateColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    searchableFields: ['nom', 'prenom', 'status', 'dateDebut', 'dateFin'],
  };
};
